export const constants = {
  SECRETS_LS_KEY: 'dfv-secrets',
};
